import React from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import subscribe from "../../assets/images/subscribe.png";

import {
    Container,
    Grid,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
    Collapse,
    Select,
    MenuItem,
    Dialog,
    DialogContent,
    RadioGroup,
    Radio,
    FormControlLabel,
    TablePagination,
    Stack,
    Checkbox
} from "@mui/material";
import Button from "../../components/Button/Button";
import {
    AddCircle,
    ExitToApp,
    ShareOutlined,
    Storefront,
    Twitter,
    Upload,
    WarehouseOutlined,
} from "@mui/icons-material";
import {
    get_admin
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation } from "react-router-dom";

export default function Admin() {
    const classes = useStyles();
    const navigate = useNavigate();
    const location = useLocation();

    const [sort, setSort] = React.useState(0);

    const handleChangeSort = (event) => {
        setSort(event.target.value);
    };

    const [searchKey, setSearchKey] = React.useState("");
    const handleSearch = (event) => {
        setSearchKey(event.target.value);
    };


    const [loading, setLoading] = React.useState(false)
    const [totalList, setTotalList] = React.useState(1);
    const [pageNum, setPageNum] = React.useState(0);

    const [customer, setcustomer] = React.useState(null);

    const getData = () => {
        setLoading(true);
        get_admin({
            page: pageNum + 1,
            // sort: sort
        }).then((json) => {
            setLoading(false);
            setcustomer(json.table);
            setTotalList(json.total);
        });
    };

    React.useEffect(() => {
        getData();
    }, [pageNum, sort]);

    const handleChangePage = (e, ispage) => {
        setPageNum(ispage);
        // getData();
    };

    const handleHeader = (e) => {
        navigate("/" + e.target.value)
    }

    return (
        <React.Fragment>
            {loading ?
                <div style={{ margin: 'auto' }}>
                    <Loader type="bubble-loop" bgColor="#1A5386" size={50} />
                </div>
                :
                <Navbar2
                    children={
                        <Section pd="2rem">
                            <div>
                                <div className={classes.theFlexHeader}>
                                    <Paragraph color="#1A5386" bold="600" size="24px">
                                        Admin
                                    </Paragraph>


                                    <div className={classes.theFlexBtn} style={{ marginBottom: "0" }}>
                                        {/* <a
                                        className={classes.theCustomActionBtn}
                                    // onClick={() => handleOpenStockMove()}
                                    >
                                        <AddCircle sx={{ color: "#1A5386" }} />
                                        <Paragraph margin="0 0 0 .4rem">Create New Order</Paragraph>
                                    </a> */}
                                        {/* <a
                                            className={classes.theCustomActionBtn_}
                                        // onClick={() => handleOpenStockMove()}
                                        >
                                            <ExitToApp sx={{ color: "#1A5386" }} />
                                            <Paragraph margin="0 0 0 .4rem">Export</Paragraph>
                                        </a> */}
                                    </div>
                                </div>
                                <div
                                    style={{
                                        borderBottom: "2px solid #707070",
                                        padding: ".2rem 0",
                                    }}
                                />
                                <br />

                                <div className={classes.theFlexAction}>
                                    <div className={classes.theWx} style={{ margin: "0 20px 0 0" }}>
                                        <FormInputNoLabel
                                            placeholder="Search"
                                            border="1px solid #d7d7d7"
                                            br="6px"
                                            onChange={handleSearch}
                                            value={searchKey}
                                        />
                                    </div>
                                    {/* <div className={classes.theWx} style={{ margin: "0 20px 0 0" }}>
                                    <FormInputNoLabel
                                        placeholder="Search"
                                        border="1px solid #d7d7d7"
                                        br="6px"
                                        onChange={(e) => console.log(e.target.value)}
                                        value={searchKey}
                                        type="date"
                                    />
                                </div> */}
                                    {/* <div className={classes.theWx}>
                                    <div className={classes.theFlex_}>
                                        <FormInputSelect>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={sort}
                                                // defaultValue={sort}
                                                onChange={handleChangeSort}
                                            >
                                                <MenuItem value="0" style={{ color: "#000" }}>
                                                    All Payment Type
                                                </MenuItem>
                                                <MenuItem value="1" style={{ color: "#000" }}>
                                                    Paid
                                                </MenuItem>
                                                <MenuItem value="2" style={{ color: "#000" }}>
                                                    On Hold
                                                </MenuItem>
                                                <MenuItem value="3" style={{ color: "#000" }}>
                                                    Cancelled
                                                </MenuItem>
                                            </Select>
                                        </FormInputSelect>
                                    </div>
                                </div> */}
                                </div>

                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <Card className={classes.theCard}>
                                            <TableContainer>
                                                <Table>
                                                    <TableHead style={{ backgroundColor: "#1A5386" }}>
                                                        <TableRow>
                                                            <TableCell style={{ borderRadius: "10px 0 0 10px" }} className={classes.theHeadTitle}>
                                                                Name
                                                            </TableCell>
                                                            <TableCell className={classes.theHeadTitle}>
                                                                Role
                                                            </TableCell>
                                                            <TableCell className={classes.theHeadTitle}>
                                                                Contact Number
                                                            </TableCell>
                                                            <TableCell style={{ borderRadius: "0 10px 10px 0" }} className={classes.theHeadTitle}>
                                                                Email
                                                            </TableCell>
                                                            {/* <TableCell className={classes.theHeadTitle}>
                                                            Credit Limit
                                                        </TableCell>
                                                        <TableCell style={{ borderRadius: "0 10px 10px 0" }} className={classes.theHeadTitle}>
                                                            Balance
                                                        </TableCell> */}
                                                            {/* <TableCell style={{ borderRadius: "0 10px 10px 0" }} className={classes.theHeadTitle}>
                                                            Amount
                                                        </TableCell> */}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {customer != null &&
                                                            customer.map((item, index) => {
                                                                if (searchKey != "") {
                                                                    if ((item.entityid).toUpperCase().indexOf(searchKey.toUpperCase()) <= -1) {
                                                                        return
                                                                    }
                                                                }
                                                                return (
                                                                    <TableRow>
                                                                        <a
                                                                            style={{ display: "contents" }}
                                                                        // href={`../saledetail/${item.sales_order_id}`}
                                                                        >
                                                                            {/* <TableCell>
                                                                                <Checkbox
                                                                                    sx={{
                                                                                        color: "#1A5386",
                                                                                        '&.Mui-checked': {
                                                                                            color: "#1A5386",
                                                                                        },
                                                                                    }} />
                                                                            </TableCell> */}
                                                                            <TableCell className={classes.theUnderLineLabel}
                                                                                onClick={() => navigate("/admindetail/" + item.admin_id)}
                                                                            >
                                                                                {item.entityid != "" && item.entityid != null ? item.entityid : "-"}
                                                                            </TableCell>
                                                                            <TableCell
                                                                                onClick={() => navigate("/admindetail/" + item.admin_id)}
                                                                            >
                                                                                {item.role != "" && item.role != null ? item.role : "-"}
                                                                            </TableCell>
                                                                            <TableCell
                                                                                onClick={() => navigate("/admindetail/" + item.admin_id)}
                                                                            >
                                                                                {item.contact != "" && item.contact != null ? item.contact : "-"}
                                                                            </TableCell>
                                                                            <TableCell
                                                                                onClick={() => navigate("/admindetail/" + item.admin_id)}
                                                                            >
                                                                                {item.email != "" && item.email != null ? item.email : "-"}
                                                                            </TableCell>
                                                                            {/* <TableCell
                                                                            onClick={() => navigate("/admindetail/" + item.admin_id)}
                                                                        >
                                                                            RM{item.creditlimit}
                                                                        </TableCell>
                                                                        <TableCell
                                                                            onClick={() => navigate("/admindetail/" + item.admin_id)}
                                                                        >
                                                                            RM{item.balance}
                                                                        </TableCell> */}
                                                                            {/* <TableCell
                                                                            onClick={() => navigate("/admindetail/" + item.admin_id)}
                                                                        >
                                                                            RM{item.total_amount}
                                                                        </TableCell> */}
                                                                        </a>
                                                                    </TableRow>
                                                                );
                                                            })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                            <div style={{
                                                borderTop: "1px solid #707070",
                                                borderBottom: "1px solid #707070",
                                                margin: "1rem 0 0",
                                                cursor: "pointer",
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                alignItems: "flex-end",
                                            }}>
                                                <TablePagination
                                                    // variant="outlined"
                                                    color="primary"
                                                    page={pageNum}
                                                    onPageChange={handleChangePage}
                                                    count={totalList}
                                                    // defaultPage={pageList}
                                                    rowsPerPage={10}
                                                    rowsPerPageOptions={[10]}
                                                // count={10}
                                                />
                                            </div>
                                        </Card>
                                        <br />
                                        <br />
                                    </Grid>
                                </Grid>
                                <br />
                                <br />
                            </div>
                        </Section>
                    }
                />
            }
        </React.Fragment>
    );
}
